<template>
  <v-container fluid>
    <v-stepper fluid flat v-model="currentStep" alt-labels :vertical="vertical">
      <template v-if="vertical">
        <template v-for="n in steps">
          <v-stepper-step
            :key="`${n}-step`"
            :complete="currentStep > n"
            :step="n"
            :editable="highestStep >= n"
          >
            {{ labels[n - 1] }}
          </v-stepper-step>

          <v-stepper-content :key="`${n}-content`" :step="n">
            <v-card ref="step_container" class="mb-12">
              <DForm
                :key="formKey"
                :ref="'dform' + n"
                v-if="rendered"
                :hideReadOnly="true"
                :afterSubmit="afterSubmit(n)"
                :data_object="formData(n)"
              />
            </v-card>
            <v-bottom-navigation fixed>
              <v-btn color="success" @click="nextStep(n)">
                Continue
              </v-btn>

              <v-btn text>Cancel</v-btn>
            </v-bottom-navigation>
          </v-stepper-content>
        </template>
      </template>
      <template v-if="!flat">
        <!-- <v-navigation-drawer fixed="fixed"> -->

        <v-stepper-header
          :class="{
            'ml-n8 mr-n8 ': $vuetify.breakpoint.smAndDown,
            'ma-0': $vuetify.breakpoint.mdAndUp
          }"
          flat
        >
          <template v-for="n in steps">
            <v-stepper-step
              :class="{
                'ma-0': $vuetify.breakpoint.smAndDown
              }"
              flat
              :key="`${n}-step`"
              :complete="highestStep + 1 >= n"
              :step="n"
              :editable="highestStep + 1 >= n"
              :edit-icon="stepObjects[n - 1].data_object.edit_icon || `$edit`"
            >
              {{ stepObjects[n - 1].data_object.title }}
            </v-stepper-step>

            <v-divider v-if="n !== steps" :key="n"></v-divider>
          </template>
        </v-stepper-header>
        <!-- </v-navigation-drawer> -->
        <v-stepper-items flat fluid>
          <v-stepper-content
            flat
            v-for="n in steps"
            :key="`${n}-content`"
            :step="n"
          >
            <v-card flat class="mb-12 ma-0 ">
              <v-container
                fluid
                class="pa-2 d-flex flex-row-reverse"
                v-if="stepObjects[n - 1].description"
              >
                {{ stepObjects[n - 1].description }}
              </v-container>
              <!-- <div v-if="n == 5">
                {{
                  stepObjects[n - 1].data_object.model[
                    stepObjects[n - 1].stepName
                  ]
                }}
              </div> -->
              <component
                flat
                :is="comps[n - 1]"
                :key="keys[n - 1]"
                :ref="'comp' + n"
                v-if="
                  stepObjects[n - 1].data_object.schema ||
                    stepObjects[n - 1].data_object.listSchema ||
                    stepObjects[n - 1].getFreshData
                "
                v-bind="stepObjects[n - 1]"
                :v-bind="stepObjects[n - 1]"
              />
            </v-card>

            <v-container
              :style="
                $vuetify.breakpoint.mdAndUp
                  ? {
                      position: 'fixed',
                      bottom: '2px',
                      left: '80px',
                      'margin-left': '100px',
                      'background-color': '#f8f8f8',
                      'z-index': '10000'
                    }
                  : ''
              "
            >
              <div
                :style="{
                  width: '100%'
                }"
              >
                <v-btn
                  color="primary"
                  :style="
                    $vuetify.breakpoint.mdAndUp
                      ? {
                          display: 'block !important',
                          margin: '0 auto !important'
                        }
                      : ''
                  "
                  @click="nextStep(n)"
                >
                  {{ highestStep >= n ? "Save" : "Continue" }}
                </v-btn>
              </div>
            </v-container>
            <!-- <v-card-actions class="pt-0"> -->

            <!-- </v-card-actions> -->
            <!-- <v-btn text>Cancel</v-btn> -->
            <!-- </v-bottom-navigation> -->
          </v-stepper-content>
        </v-stepper-items>
      </template>
      <template v-if="flat">
        <!-- {{ panels }} -->
        <component
          :is="stepObjects[0].collapsible ? 'v-expansion-panels' : 'div'"
          v-model="panels"
          multiple
        >
          <template v-for="n in steps">
            <v-slide-y-transition :key="keys[n - 1]">
              <!-- <component
                v-if="
                  !stepObjects[n - 1].minStep ||
                    stepObjects[n - 1].minStep <= highestStep
                "
                :class="
                  $vuetify.breakpoint.mdAndUp
                    ? stepObjects[n - 1].collapsible
                      ? 'ma-0 pa-2'
                      : ''
                    : ''
                "
                :is="
                  stepObjects[n - 1].collapsible ? 'v-expansion-panels' : 'div'
                "
              > -->
              <component
                :is="
                  stepObjects[n - 1].collapsible
                    ? 'v-expansion-panel'
                    : 'v-card'
                "
                v-if="
                  !stepObjects[n - 1].minStep ||
                    stepObjects[n - 1].minStep <= highestStep
                "
                elevation-20
                :class="{
                  'ma-2 pa-2': $vuetify.breakpoint.mdAndUp
                }"
              >
                <component
                  :ref="stepObjects[n - 1].stepName"
                  :is="
                    stepObjects[n - 1].collapsible
                      ? 'v-expansion-panel-header'
                      : 'v-card-title'
                  "
                >
                  <h4
                    :class="
                      !stepObjects[n - 1].collapsible
                        ? `subheading grey--text`
                        : `subheading grey--text`
                    "
                    elevation-10
                    :style="
                      !stepObjects[n - 1].collapsible
                        ? ''
                        : 'font-size:20px; margin-left:-2px;'
                    "
                  >
                    {{ stepObjects[n - 1].data_object.title }}
                  </h4>
                </component>
                <component
                  :is="
                    stepObjects[n - 1].collapsible
                      ? 'v-expansion-panel-content'
                      : 'v-card-text'
                  "
                >
                  <component
                    :is="comps[n - 1]"
                    :ref="'comp' + n"
                    v-if="
                      stepObjects[n - 1].data_object.schema ||
                        stepObjects[n - 1].data_object.listSchema ||
                        stepObjects[n - 1].getFreshData
                    "
                    v-bind="stepObjects[n - 1]"
                    :v-bind="stepObjects[n - 1]"
                  />
                </component>
                <!-- {{ currentStep }}:{{ n }}:{{ highestStep }} -->

                <v-container
                  :style="
                    $vuetify.breakpoint.mdAndUp
                      ? {
                          position: 'fixed',
                          bottom: '2px',
                          left: '80px',
                          'margin-left': '100px',
                          'background-color': '#f8f8f8',
                          'z-index': '10000'
                        }
                      : {
                          position: 'fixed',
                          bottom: '0',
                          'background-color': '#f8f8f8',
                          'z-index': '10000'
                        }
                  "
                >
                  <div
                    :style="{
                      width: '100%'
                    }"
                  >
                    {{ stepObjects[n - 1].minStep }}:{{ currentStep }}:{{
                      highestStep
                    }}
                    <v-btn
                      v-if="
                        parseInt(stepObjects[n - 1].minStep) + 1 ==
                          currentStep ||
                          n == stepObjects.length ||
                          !stepObjects[n - 1].minStep
                      "
                      color="primary"
                      :loading="loading"
                      :style="
                        $vuetify.breakpoint.mdAndUp
                          ? {
                              display: 'block !important',
                              margin: '0 auto !important'
                            }
                          : ''
                      "
                      @click="nextStep(n)"
                    >
                      {{ highestStep >= n ? "Save" : "Continue" }}
                    </v-btn>
                  </div>
                </v-container>
                <!-- <v-card-actions>
                <v-btn
                  v-if="!highestStep || n == stepObjects.length"
                  color="primary"
                  @click="nextStep(n)"
                >
                  {{ highestStep ? "Save" : "Continue" }}
                </v-btn>
              </v-card-actions> -->
              </component>
              <!-- </component> -->
            </v-slide-y-transition>
          </template>
        </component>
      </template>
    </v-stepper>

    <!-- <v-bottom-navigation fixed> -->

    <!-- </v-bottom-navigation> -->
  </v-container>
</template>

<script>
// import DForm from "../components/Form";
import Vue from "vue";
import VueSession from "vue-session";
import * as fun from "../plugins/common";
Vue.use(VueSession);
export default {
  components: {
    // DForm,
  },
  props: {
    stepObjects: Array,
    vertical: Boolean,
    flat: Boolean,
    e1: Number,
    highestStep: Number
  },
  data() {
    return {
      currentKey: 0,
      loading: false,
      altLabels: false,
      panels: [],
      data_object: {},
      fixed: true,
      currentForm: null,
      submitted: false,
      currentStep: 1,
      comps: [],
      labels: [],
      keys: []
    };
  },

  watch: {
    steps(val) {
      if (!this.e1) {
        this.currentStep = 1;
      }
      if (this.currentStep > val) {
        this.currentStep = val;
      }
    },

    vertical() {
      this.currentStep = 2;
      requestAnimationFrame(() => (this.currentStep = 1)); // Workarounds
    }
  },
  computed: {
    steps() {
      return this.stepObjects.length;
    },
    editable(n) {
      return this.highestStep >= n;
    }
  },
  mounted() {
    this.data_object = this.stepObjects[0].data_object;

    this.rendered = this.data_object.step_type == "Form";

    var that = this;

    this.stepObjects.forEach(function(obj, i) {
      var c = obj.data_object.step_type;
      that.labels.push(obj.title);
      that.comps.push(() => import("@/components/" + c));
      that.keys.push(i);
      if (!obj.collapsed) {
        that.panels.push(i);
      }
    });
    if (!this.e1) {
      this.currentStep = 1;
    } else {
      this.currentStep = this.e1;
      if (this.stepObjects.length < this.currentStep) {
        this.currentStep = this.stepObjects.length;
      }
    }
    // console.log(this.stepObjects)
  },

  methods: {
    rendered() {
      //   console.log(a);
      return true;
    },

    isCurrentStep(n) {
      return this.currentStep == n;
    },
    move(back) {
      if (!back) {
        this.currentStep += 1;
        // this.currentStep += 1;
      } else {
        this.currentStep -= 1;
      }
    },

    nextStep(n, back) {
      // var isForm = this.stepObjects[n - 1].data_object.step_type === "Form";
      // if (isForm) {
      var currentForm = this.$refs["comp" + this.currentStep][0];

      if (currentForm) {
        fun.copyObject(
          this.stepObjects[n - 1].data_object,
          currentForm.data_object
        );
        // currentForm.data_object = this.stepObjects[n - 1].data_object;

        this.currentKey = !this.currentKey;

        if (!back) {
          var options = {
            n: n,
            nextStep: this.highestStep < n
          };
          if (currentForm.data_object.step_type == "Form") {
            currentForm.submit(options);
          } else {
            this.move();
          }
        }
      }

      this.rendered = this.data_object.step_type == "Form";
      // } else {
      //   if (this.highestStep && this.highestStep >= n) {
      //     this.move();
      //   }
      // }
    },

    formData(n) {
      this.data_object = this.stepObjects[n].data_object;
      //   console.log(this.data_object);
      return this.data_object;
    }
  }
};
</script>
